import { useQuery } from "@tanstack/react-query";
import { accountabilityService } from "@/services/accountabilityService";

/**
 * Accountability page data: DRIs ranked by task count + who is blocking whom.
 * Admin-only page, so no `enabled` gate here — the route itself is protected.
 */
export function useAccountabilityOverview() {
  return useQuery({
    queryKey: ["accountability"],
    queryFn: accountabilityService.getOverview,
  });
}
